document.addEventListener("DOMContentLoaded", function () {
  var wrapper = document.getElementById("custom-products-wrapper");
  if (!wrapper) return;

  let selectedProductIds = new Set();
  let selectedBasicProductIds = new Set();
  let selectedPremiumProductIds = new Set();
  let selectedProductNames = new Set();
  let allFetchedProducts = [];
  const allCutomerTags = document.querySelector(".popup__overlay.show-all-products");
  let requiredTag = "";
  if (allCutomerTags) {
    const tagsData = allCutomerTags.getAttribute("data-tags") || "";
    const customerTags = tagsData.split(",").map(tag => tag.trim()).filter(Boolean);
    const hasRose = customerTags.includes("plan_rose");
    const hasGold = customerTags.includes("plan_gold");
    const hasPlatinum = customerTags.includes("plan_platinum");
    const hasBasic = customerTags.includes("plan_basic");
    const hasPremium = customerTags.includes("plan_premium");
  
    if (hasRose && hasGold && hasPlatinum && hasBasic && hasPremium) {
      requiredTag = "";
    } else if (hasPlatinum) {
      requiredTag = "plan_platinum";
    } else if (hasGold) {
      requiredTag = "plan_gold";
    } else if (hasRose) {
      requiredTag = "plan_rose";
    } else if (hasPremium) {
      requiredTag = "plan_premium";
    } else if (hasBasic) {
      requiredTag = "plan_basic";
    } else {
      requiredTag = "";
    }
  }
  
  const dateInput = document.getElementById("delivery-date");
  const minDaysInput = document.getElementById("min-days-ahead");
  const minDays = parseInt(minDaysInput?.value || "3");

  const today = new Date();
  today.setDate(today.getDate() + minDays);
  const minDate = today.toISOString().split("T")[0];
  dateInput.setAttribute("min", minDate);

  var customerEmail = wrapper.dataset.email;
  if (!customerEmail) {
    wrapper.innerHTML = "<p>No customer email found.</p>";
    return;
  }

  var email = encodeURIComponent(customerEmail);
  const loadTag = ""; // Or "sell" if needed
  var wrapper = document.getElementById("custom-products-wrapper");
  if (!wrapper) return;
  loadCustomProducts(email, loadTag);

  function loadCustomProducts(emailParam, optionalTag = "", col = 3, plan="") {
    const tagParam = optionalTag
      ? `&tag=${encodeURIComponent(optionalTag)}`
      : "";
    const containerId = optionalTag
      ? "custom-returns-products-wrapper"
      : "custom-products-wrapper";
    const container = document.getElementById(containerId);
    const returnBtn = document.querySelector(".show-product-btn");

    if (!container) {
      console.warn(`Container element with id "${containerId}" not found.`);
      return;
    }

    fetch(
      `https://apps.strokeinfotech.com/studio-data/customer-products?email=${emailParam}${tagParam}`
    )
      .then((res) => res.json())
      .then((data) => {
        returnBtn.style.display = "inline-block"; 
        if (!Array.isArray(data) || data.length === 0) {
          container.textContent = "No products found.";
          if(!optionalTag){
             returnBtn.style.display = "none";
          }
          return;
        }
        allFetchedProducts = data;
        container.innerHTML = "";
        const loadingText = container.querySelector(".loading-text");
        if (loadingText) loadingText.remove();
        let html;

        if(plan.includes("plan_rose")) {
          console.log("--rose");
           html = generateProductBasic(
            allFetchedProducts,
            col,
            optionalTag,
            plan
          );
        } else if(plan.includes("plan_gold")) {
          console.log("--gold");
          html = generateProductPremium(
            allFetchedProducts,
            col,
            optionalTag,
            plan
          );
        } else if(plan.includes("plan_platinum")) {
          console.log("--platinum");
           html = generateProductBasic(
            allFetchedProducts,
            col,
            optionalTag,
            plan
          );
        } else if(plan.includes("plan_basic")) {
          console.log("--basic");
           html = generateProductBasic(
            allFetchedProducts,
            col,
            optionalTag,
             plan
          );
        } else if(plan.includes("plan_premium")) {
          console.log("--premium");
          html = generateProductPremium(
            allFetchedProducts,
            col,
            optionalTag,
             plan
          );
        } else if(optionalTag) {
          console.log("---");
          html = generateProductGridHTML(
            allFetchedProducts,
            col,
            optionalTag
          );
        } else {
          html = generateProductGridHTML(
            allFetchedProducts
          );
        }
       
        if (container) {
          container.innerHTML = ""; // clear previous content
          const div = document.createElement("div");
          div.innerHTML = html;
          container.appendChild(div);
        }

        if (optionalTag) {
          const allCards = container.querySelectorAll(".product-card-wrapper");
          allCards.forEach((card) => {
            card.style.cursor = "pointer";
            card.addEventListener("click", function () {
              const badgeWrapper = this.querySelector(".badge-wrapper");
              const mediaWrapper = this.querySelector(".media");
              const productId = this.dataset.productId;
              const productName = card.dataset.productName;
              let existingIcon =
                badgeWrapper.querySelector(".added-check-icon");

              // Ensure positioning is correct
              badgeWrapper.style.position = "absolute";
              badgeWrapper.style.zIndex = "999999";

              if (existingIcon) {
                existingIcon.remove();
                mediaWrapper.style.border = "none";
                selectedProductIds.delete(productId); // Remove product from selected set
                selectedProductNames.delete(productName);
              } else {
                const checkIcon = document.createElement("div");
                checkIcon.className =
                  "card__badge bottom left added-check-icon";
                checkIcon.innerHTML = `<span class="badge">✔</span>`;
                badgeWrapper.appendChild(checkIcon);
                mediaWrapper.style.border = "1px solid";
                selectedProductIds.add(productId); // Add product to selected set
                selectedProductNames.add(productName);
              }

              validateReturnConditions();
            });
          });
        }
      })
      .then(() => {
        // Products loaded into the DOM
        filterProductsByActiveTab();
      })
      .then(() => {
        // Products loaded into the DOM
        filterProductsByTag();
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  }

  // bind click and assign product id for popup
  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("sell-confirm")) {
      const productId = e.target.dataset.productId;
      document
        .getElementById("sell-btn")
        .setAttribute("data-product-id", `${productId}`);
    }
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("sell-confirm")) {
      const popup = document.querySelector(".sell-popup");
      const parentDiv = e.target.closest(".grid__item");
      const dataIndex = parentDiv.dataset.index;
      if (popup) {
        popup.classList.add("popup-show");
        popup.setAttribute("data-product-index", dataIndex);
      }
    }
  });

  function validateReturnConditions() {
    const selectedDate = document.getElementById("delivery-date")?.value;
    const proceedBtn = document.querySelector(
      ".custom-buttons-wrapper .btn.return-item"
    );
  
    if (!proceedBtn) return;
  
    // Get active tab's data-tab (e.g., plan_basic or plan_premium)
    const activeTab = document.querySelector(".tab.plan-active");
    if(activeTab) {
      requiredTag = activeTab?.dataset.tab || "plan_rose"; // fallback to basic
    } else {
      requiredTag
    }
    // Set item count requirement based on active plan
    let requiredItemCount = 1;
    if (requiredTag === "plan_premium") {
      requiredItemCount = 1;
    } else if (requiredTag === "plan_basic") {
      requiredItemCount = 3;
    }
  
    // Enable or disable proceed button based on conditions
    if (selectedProductIds.size >= requiredItemCount && selectedDate !== "") {
      proceedBtn.classList.remove("disabled");
      proceedBtn.classList.add("proceed-return-item");
    } else {
      proceedBtn.classList.add("disabled");
      proceedBtn.classList.remove("proceed-return-item");
    }
  }


  document
    .getElementById("choose-date-form")
    .addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent actual form submission
      const selectedDate = document.getElementById("delivery-date").value;
      const popup = document.querySelector(".select-date");
      const dateDisplay = document.getElementById("selected-date-display");
      if (selectedDate != "") {
        dateDisplay.textContent = `Selected Delivery Date: ${selectedDate}`;
        popup.classList.remove("popup-show");
        validateReturnConditions();
      } else if (!selectedDate) {
        dateDisplay.textContent = "";
        validateReturnConditions();
        popup.classList.remove("popup-show");
        return;
      }
    });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("show-product-btn")) {
      const popup = document.querySelector(".show-all-products");
      const plan = popup.dataset.tags;
      if (popup) {
        popup.classList.add("popup-show");
      }

      const wrapper = document.getElementById(
        "custom-returns-products-wrapper"
      );
      if (!wrapper) return;
    
      loadCustomProducts(email, "sale", 4, plan);
      filterProductsByActiveTab();
      filterProductsByTag();
    }
  });

  function filterProductsByActiveTab() {
    const activeTab = document.querySelector(".tab.plan-active");
    if (!activeTab) return;
    
    const activePlan = activeTab.getAttribute("data-tab");
    const wrapper = document.querySelector("#custom-returns-products-wrapper");
    if (!wrapper) return;
  
    // Get all grid__item elements inside the wrapper
    const allItems = wrapper.querySelectorAll(".grid__item");
    let hasVisibleItem = false;
    allItems.forEach((item) => {
      const dataReturn = item.getAttribute("data-return");
      const dataTag = item.getAttribute("data-tag") || "";
  
      // Only show items with data-return="sell" and matching active plan
      if (dataReturn === "sale" && dataTag.includes(activePlan)) {
        item.style.display = "block";
        hasVisibleItem = true;
      } else {
        item.style.display = "none";
      }
      const notFoundMessage = document.querySelector(".no-products-message"); // Add this in HTML

      if (notFoundMessage) {
        notFoundMessage.style.display = hasVisibleItem ? "none" : "block";
      }
    });
  }

  function filterProductsByTag() {
    const overlay = document.querySelector(".popup__overlay.show-all-products");
    const wrapper = document.querySelector("#custom-returns-products-wrapper");
    let hasVisibleItem = false;
  
    if (!overlay || !wrapper) return;

    if (!requiredTag) return;
    const allItems = wrapper.querySelectorAll(".grid__item");
    allItems.forEach((item) => {
      const itemTags = item.getAttribute("data-tag") || "";
      const shouldShow = itemTags.split(",").includes(requiredTag);

      if(shouldShow) {
        item.style.display = "block";
        hasVisibleItem = true;
      } else {
        item.style.display = "none";
      }
      const notFoundMessage = document.querySelector(".no-products-message"); // Add this in HTML

      if (notFoundMessage) {
        notFoundMessage.style.display = hasVisibleItem ? "none" : "block";
      }
    });
  }

  document.querySelector(".popup__overlay.show-all-products")?.classList.contains("popup-show") && filterProductsByTag();
  filterProductsByTag();
  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("choose-date")) {
      const popup = document.querySelector(".select-date");
      if (popup) {
        popup.classList.add("popup-show");
      }
    }
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("proceed-return-item")) {
      const deliveryDate = document.getElementById("delivery-date")?.value;
      if (!deliveryDate) {
        alert("Please select a delivery date before proceeding.");
        return;
      }
      const popup = document.querySelector(".show-all-products");
      if (popup) {
        popup.classList.remove("popup-show");
      }

      let variantId;
      if(requiredTag == "plan_platinum") {
        variantId = 62558549999987;
      } else if (requiredTag == "plan_rose" || requiredTag == "plan_gold") {
        variantId = 62558552162675;
      } else if(requiredTag == "plan_premium") {
        variantId = 52696074912115;
      } else if (requiredTag == "plan_basic") {
        variantId = 52696070816115;
      }
      
      
      // Add product to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId, // Replace with dynamic product variant ID if needed
          quantity: 1,
          properties: {
            "Delivery Date": deliveryDate,
            "Return Products": Array.from(selectedProductNames).join(", "),
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Refresh the cart drawer
          fetch("/?section_id=cart-drawer")
            .then((res) => res.text())
            .then((html) => {
              const newDrawer = new DOMParser()
                .parseFromString(html, "text/html")
                .querySelector("cart-drawer");

              const cartDrawer = document.querySelector("cart-drawer");
              if (cartDrawer && newDrawer) {
                cartDrawer.innerHTML = newDrawer.innerHTML;
                cartDrawer.classList.add("active", "animate");
                cartDrawer.classList.remove("is-empty");
                document.body.classList.add("overflow-hidden");
              }
              resetReturnForm();
            });
        })
        .catch((err) => {
          console.error("Failed to add to cart:", err);
          alert(
            "There was a problem adding the item to your cart. Please try again."
          );
        });
    }
  });

  var sell_button = document.getElementById("sell-btn");
  const priceInput = document.getElementById("price");

  priceInput.addEventListener("input", () => {
    const value = parseFloat(priceInput.value);
    if (!isNaN(value) && value >= 1) {
      sell_button.disabled = false;
      sell_button.classList.remove("disabled");
    } else {
      sell_button.disabled = true;
      sell_button.classList.add("disabled");
    }
  });

  sell_button.addEventListener("click", function (e) {
    e.preventDefault();
    const rawValue = priceInput.value.trim();
    const priceValue = parseFloat(rawValue);
    if (isNaN(priceValue)) return;
    
    const roundedPrice = priceValue.toFixed(2);
    const newTag = `sale,sale-price-${roundedPrice}`;
    
    const productId = "gid://shopify/Product/" + sell_button.dataset.productId;
    const collectionId = "gid://shopify/Collection/646200623475";
    const removeButtons = document.querySelector(".cart__action");
    const allProductItems = document.querySelectorAll(
      "#product-grid .grid__item"
    );
    sell_button.querySelector("span").style.visibility = "hidden";
    sell_button.querySelector(".loader").style.display = "block";
    if (productId) {
      fetch(`https://apps.strokeinfotech.com/studio-data/assign-tag`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productId: productId,
          newTag: newTag,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          sell_button.querySelector("span").style.visibility = "visible";
          sell_button.querySelector(".loader").style.display = "none";
          if (data.success) {
            const sellPopup = document.querySelector(".sell-popup");
            const productIndex = sellPopup.getAttribute("data-product-index");

            const matchingGridItem = document.querySelector(
              `#product-grid .grid__item[data-index="${productIndex}"]`
            );

            if (matchingGridItem) {
              const badgeWrapper =
                matchingGridItem.querySelector(".badge-wrapper");
              const removeButtons =
                matchingGridItem.querySelector(".cart__action");

              if (
                badgeWrapper &&
                !badgeWrapper.querySelector(".custom-sale-badge")
              ) {
                const badgeHTML = document.createElement("div");
                badgeHTML.className =
                  "card__badge bottom left custom-sale-badge";
                badgeHTML.innerHTML =
                  '<span class="badge color-scheme-4">For Sale</span>';
                badgeWrapper.appendChild(badgeHTML);

                if (removeButtons) removeButtons.remove();
              }

              sellPopup.classList.remove("popup-show");
            }
            fetch(
              `https://apps.strokeinfotech.com/studio-data/assign-collection`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  productId: productId,
                  collectionId: "gid://shopify/Collection/646200623475",
                }),
              }
            )
              .then((res) => res.json())
              .then((response) => {
                console.log("Collection assigned successfully:", response);
              })
              .catch((err) => {
                console.error("Failed to assign collection:", err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Error occurred while adding tag.");
        });
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("popup__close")) {
      e.preventDefault();
      const popup = e.target.closest(".popup__overlay");
      if (popup && popup.classList.contains("popup-show")) {
        popup.classList.remove("popup-show");
        resetReturnForm();
      }
    }
  });

  function resetReturnForm() {
    selectedProductIds.clear();
    selectedProductNames.clear();

    const dateInput = document.getElementById("delivery-date");
    if (dateInput) dateInput.value = "";

    const dateDisplay = document.getElementById("selected-date-display");
    if (dateDisplay) dateDisplay.textContent = "";

    const proceedBtn = document.querySelector(
      ".custom-buttons-wrapper .btn.return-item"
    );
    if (proceedBtn) {
      proceedBtn.classList.add("disabled");
      proceedBtn.classList.remove("active");
    }

    const allCards = document.querySelectorAll(".product-card-wrapper");
    allCards.forEach((card) => {
      const badgeWrapper = card.querySelector(".badge-wrapper");
      const mediaWrapper = card.querySelector(".media");

      if (badgeWrapper) {
        const existingIcon = badgeWrapper.querySelector(".added-check-icon");
        if (existingIcon) existingIcon.remove();
      }

      if (mediaWrapper) {
        mediaWrapper.style.border = "none";
      }
    });
  }

  document.querySelectorAll(".tab").forEach((tab) => {
    tab.addEventListener("click", () => {
      // Handle tab UI
      document.querySelectorAll(".tab").forEach((t) =>
        t.classList.remove("plan-active")
      );
      tab.classList.add("plan-active");
  
      // Update the return info section
      const selectedPlan = tab.getAttribute("data-tab");
      console.log(selectedPlan, "selectedPlan");
      
      updateReturnPolicyContent(selectedPlan);
  
      // Trigger any other logic, such as filtering products
      filterProductsByActiveTab();
      const popup = document.querySelector(".show-all-products");
      const plan = popup.dataset.tags;
      resetReturnForm();
    });
  });

  const tabsExist = document.querySelector(".custom-tabs");

  if (!tabsExist) {
    // Fallback to default plan (e.g., requiredTag = "plan_basic" or "plan_premium")
    console.log(requiredTag, "==requiredTag");
    
    updateReturnPolicyContent(requiredTag);
  }
  
  function updateReturnPolicyContent(plan) {
    const subheadingContainer = document.querySelector(".return-item-subheading");
  
    if (!subheadingContainer) return;
  
    let content = `
      <p><strong>Please read the terms below before proceeding:</strong></p>
      <ul>
    `;
    console.log(plan, "===plan");
    
    if (plan === "plan_rose" || plan === "plan_gold") {
      content += `
        <li>A flat $10 delivery fee applies per return.</li>
        <li>Please note, each return request must include a minimum of 3 items.</li>
      `;
    } else if (plan === "plan_platinum") {
      content += `
        <li>No delivery fees, ever.</li>
        <li>We recommend returning 3 or more items per delivery to support sustainable logistics, but we’re always happy to deliver even a single piece, whenever you need it.</li>
      `;
    } else if (plan === "plan_basic") {
      content += `
        <li>A flat $10 delivery fee applies per return.</li>
        <li>Please note, each return request must include a minimum of 3 items.</li>
      `;
    } else if (plan === "plan_premium") {
      content += `
        <li>No delivery fees, ever.</li>
        <li>We recommend returning 3 or more items per delivery to support sustainable logistics, but we’re always happy to deliver even a single piece, whenever you need it.</li>
      `;
    }
  
    content += `</ul>`;
    subheadingContainer.innerHTML = content;
  }



  function generateProductGridHTML(data, col = 3,optionalTag = "") {
    let html = `<ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--${col}-col-desktop">`;

    data.forEach((item, index) => {
      const node = item?.node;
      if (!node) return;

      const title = node.title || "Untitled";
      const productId = node.id?.split("/").pop() || "";
      const tags = node.tags || [];
      const hasSellTag = tags.includes("sale");

      const imageSrc =
        node.images?.edges?.[0]?.node?.originalSrc ||
        "https://via.placeholder.com/437x450?text=No+Image";
      const imageAlt = node.images?.edges?.[0]?.node?.altText || title;
      const imageSrcBase = imageSrc.split("?")[0];
      const imageSrcSet = `
      ${imageSrcBase}?width=165 165w,
      ${imageSrcBase}?width=360 360w,
      ${imageSrcBase}?width=437 437w,
      ${imageSrcBase}?width=533 533w
    `;

      html += `
      <li class="grid__item" data-index="${index}" data-tag="${tags}" data-return="${optionalTag}">
        <div class="card-wrapper product-card-wrapper underline-links-hover" style="cursor: pointer;" data-product-id="${productId}" data-product-name="${title}">
          <div class="card card--standard card--media" style="--ratio-percent: 102.97482837528604%;">
            <div class="card__inner color-scheme-2 gradient ratio">
              <div class="card__media">
                <div class="badge-wrapper">`;

      if (hasSellTag) {
        html += `
                  <div class="card__badge bottom left custom-sale-badge">
                    <span class="badge color-scheme-4">For Sale</span>
                  </div>`;
      }

      html += `
                </div>
                <div class="media media--transparent media--hover-effect">
                  <img
                    src="${imageSrc}?width=533"
                    srcset="${imageSrcSet}"
                    sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                    alt="${imageAlt}"
                    class="motion-reduce"
                    width="437"
                    height="450"
                  >
                </div>`;

      if (!hasSellTag && !optionalTag) {
        html += `
                <div class="cart__action" style="position: absolute; bottom: 0; width: 100%;">
                  <a class="sell-confirm button btn" data-product-id="${productId}" style="flex:0.5;text-decoration:none;">Sell now on Marketplace</a>
                </div>`;
      }

      html += `
              </div>
            </div>
            <div class="card__content ${
              optionalTag ? "" : "custom-products-heading"
            }">
              <div class="card__information">
                <h3 class="card__heading h5">${title}</h3>
              </div>
            </div>
          </div>
        </div>
      </li>`;
    });

    html += `</ul>`;
    return html;
  }
  function generateProductBasic(data, col = 3,optionalTag = "", plan) {
    let html = `<div class="no-products-message">No Product Found</div><ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--${col}-col-desktop">`;

    data.forEach((item, index) => {
      const node = item?.node;
      if (!node) return;

      const title = node.title || "Untitled";
      const productId = node.id?.split("/").pop() || "";
      const tags = node.tags || [];
      const hasSellTag = tags.includes("sale");

      const imageSrc =
        node.images?.edges?.[0]?.node?.originalSrc ||
        "https://via.placeholder.com/437x450?text=No+Image";
      const imageAlt = node.images?.edges?.[0]?.node?.altText || title;
      const imageSrcBase = imageSrc.split("?")[0];
      const imageSrcSet = `
      ${imageSrcBase}?width=165 165w,
      ${imageSrcBase}?width=360 360w,
      ${imageSrcBase}?width=437 437w,
      ${imageSrcBase}?width=533 533w
    `;

      html += `
      <li class="grid__item" data-index="${index}" data-tag="${tags}" data-return="${optionalTag}">
        <div class="card-wrapper product-card-wrapper underline-links-hover" style="cursor: pointer;" data-product-id="${productId}" data-product-name="${title}">
          <div class="card card--standard card--media" style="--ratio-percent: 102.97482837528604%;">
            <div class="card__inner color-scheme-2 gradient ratio">
              <div class="card__media">
                <div class="badge-wrapper">`;

      if (hasSellTag) {
        html += `
                  <div class="card__badge bottom left custom-sale-badge">
                    <span class="badge color-scheme-4">For Sale</span>
                  </div>`;
      }

      html += `
                </div>
                <div class="media media--transparent media--hover-effect">
                  <img
                    src="${imageSrc}?width=533"
                    srcset="${imageSrcSet}"
                    sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                    alt="${imageAlt}"
                    class="motion-reduce"
                    width="437"
                    height="450"
                  >
                </div>`;

      html += `
              </div>
            </div>
            <div class="card__content ${
              optionalTag ? "" : "custom-products-heading"
            }">
              <div class="card__information">
                <h3 class="card__heading h5">${title}</h3>
              </div>
            </div>
          </div>
        </div>
      </li>`;
    });

    html += `</ul>`;
    return html;
  }
  function generateProductPremium(data, col = 3,optionalTag = "", plan) {
    let html = `<div class="no-products-message">No Product Found</div><ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--${col}-col-desktop">`;

    data.forEach((item, index) => {
      const node = item?.node;
      if (!node) return;

      const title = node.title || "Untitled";
      const productId = node.id?.split("/").pop() || "";
      const tags = node.tags || [];
      const hasSellTag = tags.includes("sale");

      const imageSrc =
        node.images?.edges?.[0]?.node?.originalSrc ||
        "https://via.placeholder.com/437x450?text=No+Image";
      const imageAlt = node.images?.edges?.[0]?.node?.altText || title;
      const imageSrcBase = imageSrc.split("?")[0];
      const imageSrcSet = `
      ${imageSrcBase}?width=165 165w,
      ${imageSrcBase}?width=360 360w,
      ${imageSrcBase}?width=437 437w,
      ${imageSrcBase}?width=533 533w
    `;

      html += `
      <li class="grid__item" data-index="${index}" data-tag="${tags}" data-return="${optionalTag}">
        <div class="card-wrapper product-card-wrapper underline-links-hover" style="cursor: pointer;" data-product-id="${productId}" data-product-name="${title}">
          <div class="card card--standard card--media" style="--ratio-percent: 102.97482837528604%;">
            <div class="card__inner color-scheme-2 gradient ratio">
              <div class="card__media">
                <div class="badge-wrapper">`;

      if (hasSellTag) {
        html += `
                  <div class="card__badge bottom left custom-sale-badge">
                    <span class="badge color-scheme-4">For Sale</span>
                  </div>`;
      }

      html += `
                </div>
                <div class="media media--transparent media--hover-effect">
                  <img
                    src="${imageSrc}?width=533"
                    srcset="${imageSrcSet}"
                    sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                    alt="${imageAlt}"
                    class="motion-reduce"
                    width="437"
                    height="450"
                  >
                </div>`;

      html += `
              </div>
            </div>
            <div class="card__content ${
              optionalTag ? "" : "custom-products-heading"
            }">
              <div class="card__information">
                <h3 class="card__heading h5">${title}</h3>
              </div>
            </div>
          </div>
        </div>
      </li>`;
    });

    html += `</ul>`;
    return html;
  }
});
